export type BuildMetadata = {
  channel: string;
  sha: string;
  shortSha: string;
  version: string;
};

type BuildMetadataEnv = {
  readonly VITE_TKTIC_GIT_SHA?: string;
  readonly VITE_TKTIC_RELEASE_CHANNEL?: string;
  readonly VITE_TKTIC_RELEASE_VERSION?: string;
};

export function createBuildMetadata(env: BuildMetadataEnv): BuildMetadata {
  const version = clean(env.VITE_TKTIC_RELEASE_VERSION) || "local";
  const channel = clean(env.VITE_TKTIC_RELEASE_CHANNEL) || inferChannel(version);
  const sha = clean(env.VITE_TKTIC_GIT_SHA);

  return {
    channel,
    sha,
    shortSha: sha && sha !== "unknown" ? sha.slice(0, 7) : "",
    version,
  };
}

export function formatBuildVersionLabel(metadata: BuildMetadata): string {
  const sha = metadata.shortSha ? ` • ${metadata.shortSha}` : "";

  return `${metadata.version}${sha}`;
}

function clean(value: string | undefined): string {
  return typeof value === "string" ? value.trim() : "";
}

function inferChannel(version: string): string {
  if (version === "dev" || version === "local" || version === "main") {
    return version;
  }
  if (/^v\d+\.\d+/.test(version)) {
    return "production";
  }
  return "unknown";
}

export const buildMetadata = createBuildMetadata(import.meta.env);
